import React from 'react';
import './ContentBlock.css';
import Tile from '../Tile/Tile';
import Banner from '../Banner/Banner';
import PageTitle from '../PageTitle/PageTitle';
import Products from '../Products/Products';
import Recommendations from '../Recommendations/Recommendations';
import Separator from '../Separator/Separator';
import Html from '../Html/Html';
import Video from '../Video/Video';
import Collage from '../Collage/Collage';

const ContentBlock = props => {
  switch (props.type) {
    case 'shop-the-range':
      return <Tile {...props} className={props.type} />;
    case 'tile':
      return <Tile {...props} className={props.type} />;
    case 'banner':
      return <Banner {...props} />;
    case 'page-title':
      return <PageTitle {...props} />;
    case 'products':
      return <Products {...props} />;
    case 'recommendations':
      return <Recommendations {...props} />;
    case 'separator':
      return <Separator {...props} />;
    case 'html':
      return <Html {...props} />;
    case 'video':
      return <Video {...props} />;
    case 'collage':
      return <Collage {...props} className={props.type} />;
    default:
      return null;
  }
};

export default ContentBlock;



// WEBPACK FOOTER //
// ./src/components/landingPage/ContentBlock/ContentBlock.js